import { AmazonLink } from '../components/amazon_link'
import React from 'react'
import { formatTargetRefinements } from './target_refinements'

export const parseExpression = (target: any) => {
    if (!target) return ''

    if (target.targeting_expression && typeof target.targeting_expression === 'string') {
        return target.targeting_expression
    }

    if (target.expressions) {
        const expressions = target.expressions.map(({ type, value, resolved }: any) =>
            resolveExpression(type, value, resolved),
        )
        return expressions.join(', ')
    } else if (target.expression) {
        const expressions = target.expression.map(({ type, value, resolved }: any) =>
            resolveExpression(type, value, resolved),
        )
        return expressions.join(', ')
    }

    let { type, value } = target.expression || target || {}
    if (target.targeting_type == 'TARGETING_EXPRESSION_PREDEFINED') {
        switch (target.targeting_expression?.toLowerCase()) {
            case 'loose-match':
                return 'Loose match'
            case 'close-match':
                return 'Close match'
            case 'substitutes':
                return 'Substitutes'
            case 'complements':
                return 'Complements'
        }
    } else if (target.targeting_type === 'TARGETING_EXPRESSION') {
        if (target.targeting_expression?.includes('asin="')) {
            type = 'asinSameAs'
            value = target.targeting_expression.replaceAll('asin=', '').replaceAll('"', '')
        }
    }

    switch (type) {
        case 'asinSameAs':
            return (
                <span>
                    asin=
                    <AmazonLink asin={value} />
                </span>
            )
        case 'queryBroadRelMatches':
            return 'Loose match'
        case 'queryHighRelMatches':
            return 'Close match'
        case 'asinSubstituteRelated':
            return 'Substitutes'
        case 'asinAccessoryRelated':
            return 'Complements'
    }

    type = target.type
    value = target.expression

    switch (type) {
        case 'asinSameAs':
            return (
                <span>
                    asin=
                    <AmazonLink asin={value} />
                </span>
            )
        case 'queryBroadRelMatches':
            return 'Loose match'
        case 'queryHighRelMatches':
            return 'Close match'
        case 'asinSubstituteRelated':
            return 'Substitutes'
        case 'asinAccessoryRelated':
            return 'Complements'
    }

    if (target.target_details_keyword) {
        return target.target_details_keyword
    }

    switch (target.target_details_match_type) {
        case 'PRODUCT_EXACT':
            return target.target_details_asin
        case 'PRODUCT_SIMILAR':
            return (
                <span>
                    Expanded: <AmazonLink asin={target.target_details_asin} />
                </span>
            )
        case 'SEARCH_LOOSE_MATCH':
            return 'Loose match'
        case 'SEARCH_CLOSE_MATCH':
            return 'Close match'
        case 'PRODUCT_SUBSTITUTES':
            return 'Substitutes'
        case 'PRODUCT_COMPLEMENTS':
            return 'Complements'
        case 'KEYWORDS_RELATED_TO_GIFTS':
            return 'Keywords related to gifts'
        case 'KEYWORDS_RELATED_TO_YOUR_PRODUCT_CATEGORY':
            return 'Keywords related to product category'
    }

    // Handle PRODUCT_CATEGORY targets with refinements
    if (
        target.target_type === 'PRODUCT_CATEGORY' &&
        target.target_details_product_category_resolved
    ) {
        return formatTargetRefinements(target)
    }

    console.error('Cannot resolve expression for', type, value, target)
    return ''
}

const resolveExpression = (type: string, value: string, resolved?: any): string => {
    switch (type) {
        case 'asinSameAs':
            return `ASIN = ${value}`
        case 'queryBroadRelMatches':
            return 'Loose match'
        case 'queryHighRelMatches':
            return 'Close match'
        case 'asinSubstituteRelated':
            return 'Substitutes'
        case 'asinAccessoryRelated':
            return 'Complements'
        case 'asinPriceGreaterThan':
            return `Price > ${value}`
        case 'asinPriceLessThan':
            return `Price < ${value}`
        case 'asinPriceBetween':
            return `Price between ${value}`
        case 'asinReviewRatingBetween':
            return `Review between ${value}`
        case 'asinReviewRatingLessThan':
            return `Review < ${value}`
        case 'asinReviewRatingGreaterThan':
            return `Review > ${value}`
        case 'asinIsPrimeShippingEligible':
            return `Prime shipping = ${value}`
        case 'asinAgeRangeSameAs':
            return `Age Range = $   {value}`
        case 'asinBrandSameAs':
            return `Brand = ${resolved.brand}`
        case 'asinCategorySameAs':
            return `Category = ${resolved.category}`
        case 'asinGenreSameAs':
            return `Genre = ${resolved.genre}`
    }

    console.error('Cannot resolve expression for', type, value)
    return ''
}
